import React, { useContext, useState } from 'react';
import LocaleContext from 'locales';
import { Button, Modal, Typography } from 'antd';

/**
 * #201733 PASSWORD 분실/만료 조치 안내 모달
 * @returns React.JSX.Element
 */
export default function PasswordGuide() {
  const { locale } = useContext(LocaleContext);

  // states
  const [visible, setVisible] = useState(false); // Modal.visible

  // 모달 open/close
  const openModal = () => setVisible(true);
  const closeModal = () => setVisible(false);

  return (
    <>
      <Button type="link" style={{ padding: 0 }} onClick={openModal}>
        {locale.resource['txt.password-guide-button']}
      </Button>
      <Modal
        title={locale.resource['txt.password-guide-button']}
        width={460}
        visible={visible}
        cancelButtonProps={{ style: { display: 'none' } }}
        onOk={closeModal}
        onCancel={closeModal}
      >
        <Typography.Paragraph>
          <Typography.Text strong>{locale.resource['txt.password-guide-content1']}</Typography.Text>
          <br />
          <Typography.Text>{locale.resource['txt.password-guide-content2']}</Typography.Text>
        </Typography.Paragraph>
        <Typography.Paragraph>
          <Typography.Text strong>{locale.resource['txt.password-guide-content3']}</Typography.Text>
          <br />
          <Typography.Text>{locale.resource['txt.password-guide-content4']}</Typography.Text>
          <br />
          <Typography.Text>{locale.resource['txt.password-guide-content5']}</Typography.Text>
        </Typography.Paragraph>
        <Typography.Paragraph>
          <Typography.Text>{locale.resource['txt.password-guide-content6']}</Typography.Text>
        </Typography.Paragraph>
      </Modal>
    </>
  );
}
